import React from "react";
import CustomIconButton from "../CustomIconButton/CustomIconButton";
import CustomInputAdornment from "../CustomInputAdornment/CustomInputAdornment";
import CustomTextField from "../CustomTextField/CustomTextField";
import { useAsyncDebounce } from "react-table";
import { CustomSearchIcon } from "../CustomIcon/CustomIcon";
import { useStyles } from "../../../assets/jss/PraisoTable";

export const ColumnFilter = ({ column }) => {
  const classes = useStyles();
  const {filterValue, setFilter} = column;
  const [value, setValue] = React.useState(filterValue);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 200);
  return (
    <CustomTextField
      placeholder={`Search by`}
      className={classes.search}
      InputProps={{
        endAdornment: (
          <CustomInputAdornment position='start'>
            <CustomIconButton>
              <CustomSearchIcon />
            </CustomIconButton>
          </CustomInputAdornment>
        ),
      }}
      value={value || ""}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
    />
  );
};
